import { ApolloClient, from, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { acquireAccessToken } from "@/pages/Login/auth.config";
import { authErrorLink } from "@/services/authErrorLink";
import type { DefaultOptions } from "@apollo/client";

const withToken = setContext(async (_, { headers }) => {
  const authToken = await acquireAccessToken();
  return {
    headers: {
      ...headers,
      Authorization: authToken ? `Bearer ${authToken}` : null,
    },
  };
});

const httpLink = from([
  authErrorLink,
  new HttpLink({
    uri: import.meta.env.VITE_API_URL + "/graphql",
  }),
]);

const defaultOptions: DefaultOptions = {
  query: { fetchPolicy: "no-cache", errorPolicy: "all" },
  watchQuery: { fetchPolicy: "no-cache", errorPolicy: "all" },
  mutate: { errorPolicy: "all" },
};

const graphqlClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([withToken, httpLink]),
  defaultOptions: defaultOptions,
});

export default graphqlClient;
